import React, { FC } from 'react';

import useLastCallback from '../../hooks/useLastCallback';
import { getActions } from '../../global';
import { useGoogleLoginWithNonce } from '../../hooks/useGoogleLoginWithNonce';
import { GOOGLE_CLIENT_ID } from '../../config';

type OwnProps = {
  nonce?: string;
};

export const AuthOAuth: FC<OwnProps> = ({ nonce }) => {
  const { setAuthToken } = getActions();

  const authGoogle = useGoogleLoginWithNonce({
    clientId: GOOGLE_CLIENT_ID,
    nonce,
    onSuccess: (token) => {
      setAuthToken({ token });
    },
  });

  const handleSignInGoogle = useLastCallback(() => {
    authGoogle();
  });

  return (
    <>
      <div className='divider'>
        <span>Sign in</span>
      </div>
      <div className='social-auth'>
        <div className='social-auth-item' onClick={handleSignInGoogle}>
          <i className='icon-svg'>
            <GoogleIcon />
          </i>
          <span>Google</span>
        </div>
      </div>
    </>
  );
};

const GoogleIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='33' fill='none'>
      <g fillRule='evenodd' clipRule='evenodd'>
        <path
          fill='#4285F4'
          d='M29.44 16.753c0-.992-.09-1.947-.255-2.863H16v5.415h7.535a6.44 6.44 0 0 1-2.794 4.226v3.513h4.524c2.648-2.438 4.175-6.027 4.175-10.29Z'
        />
        <path
          fill='#34A853'
          d='M16 30.435c3.78 0 6.948-1.253 9.265-3.392l-4.525-3.512c-1.253.84-2.857 1.336-4.74 1.336-3.647 0-6.733-2.463-7.834-5.772H3.489v3.628c2.303 4.575 7.038 7.712 12.51 7.712Z'
        />
        <path
          fill='#FBBC05'
          d='M8.166 19.096a8.416 8.416 0 0 1-.439-2.66c0-.923.16-1.82.44-2.66v-3.628H3.488A13.995 13.995 0 0 0 2 16.436c0 2.259.54 4.397 1.49 6.287l4.676-3.627Z'
        />
        <path
          fill='#EA4335'
          d='M16 8.004c2.055 0 3.9.706 5.351 2.093l4.016-4.015c-2.425-2.26-5.594-3.647-9.368-3.647-5.472 0-10.207 3.138-12.51 7.713l4.677 3.627c1.1-3.309 4.187-5.771 7.833-5.771Z'
        />
      </g>
    </svg>
  );
};

const AppleIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='32' height='33' fill='none'>
      <g clipPath='url(#a)'>
        <path
          fill='#000'
          d='M27.497 22.256c-.43.978-.94 1.879-1.532 2.706-.805 1.13-1.465 1.91-1.973 2.344-.788.712-1.632 1.077-2.536 1.098-.65 0-1.432-.182-2.343-.55-.914-.366-1.754-.548-2.522-.548-.806 0-1.67.182-2.594.548-.925.368-1.67.56-2.24.579-.867.036-1.732-.339-2.594-1.127-.55-.472-1.239-1.28-2.064-2.427-.885-1.223-1.612-2.642-2.183-4.26C4.306 18.872 4 17.18 4 15.542c0-1.877.413-3.495 1.239-4.851a7.205 7.205 0 0 1 2.595-2.58 7.073 7.073 0 0 1 3.508-.973c.689 0 1.592.21 2.714.62 1.119.413 1.837.623 2.152.623.236 0 1.034-.245 2.387-.733 1.28-.452 2.36-.64 3.244-.566 2.397.19 4.198 1.119 5.396 2.792-2.144 1.276-3.204 3.064-3.183 5.358.019 1.787.678 3.273 1.975 4.454A6.5 6.5 0 0 0 28 20.958c-.158.451-.325.883-.503 1.298ZM21.999.996c0 1.4-.52 2.707-1.558 3.918-1.252 1.438-2.767 2.27-4.41 2.138a4.29 4.29 0 0 1-.033-.53c0-1.345.596-2.783 1.653-3.96.529-.595 1.2-1.09 2.014-1.485.813-.39 1.581-.605 2.304-.642a5 5 0 0 1 .03.56Z'
        />
      </g>
      <defs>
        <clipPath id='a'>
          <path fill='#fff' d='M0 .435h32v32H0z' />
        </clipPath>
      </defs>
    </svg>
  );
};
